<style lang="scss" scoped>
.warning-text {
    color: red;
    display: inline-block;
    font-size: 12px;
}
</style>
<template lang="pug">
<el-dialog class="filter__modal" title="Custom person ID" :visible.sync="dialogVisible" width="500px" :before-close="cancelModal">
    <el-form @submit.prevent.native="confirmModal">
        <el-form-item label="">
            custom-field-format(
                v-model="format",
                fieldLabel="Format",
                :fieldNames="fieldNames",
                settingKey="department_student",
                :persistedFormat="persistedFormat"
            )
            span.warning-text Leaving this blank will reset the person ID of all selected users
        </el-form-item>
        
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button :loading="processing" size="medium" style="margin-top:-10px" @click="cancelModal">Cancel</el-button>
        <el-button :loading="processing" size="medium" style="margin-top:-10px" type="primary" @click="confirmModal">Confirm</el-button>
    </span>
</el-dialog>
</template>
<script>
import _ from "lodash";
import ClickOutside from "vue-click-outside";
import CustomFieldFormat from './CustomFieldFormat';
import Bugsnag from "@bugsnag/js";
export default {
	props: {
        dialogVisible: Boolean,
        selected: Array,
        persistedFormat: String,
    },
    components: {
        CustomFieldFormat
    },
    directives: {
		ClickOutside
	},
    
    data() {
        return {
            format: null,
            fieldNames: {
                "mis-id": {
                    label: "Primary MIS/SIS ID",
                    value: "mis_id"
                },
                "mis-secondary-id": {
                    label: "Secondary MIS/SIS ID",
                    value: "mis_secondary_id"
                },
                "edusync-id": {
                    label: "Edusync ID",
                    value: "edusync_id"
                },
                "government-id": {
                    label: "Government ID",
                    value: "government_id"
                },
                "forename": {
                    label: "Preferred forename",
                    value: "forename"
                },
                "forename-1-letter": {
                    label: "First letter of preferred forename",
                    value: "forename.slice(0, 1)"
                },
                "forename-2-letters": {
                    label: "First 2 letters of preferred forename",
                    value: "forename.slice(0, 2)"
                },
                "forename-3-letters": {
                    label: "First 3 letters of preferred forename",
                    value: "forename.slice(0, 3)"
                },
                "surname": {
                    label: "Preferred surname",
                    value: "surname"
                },
                "surname-1-letter": {
                    label: "First letter of preferred surname",
                    value: "surname.slice(0, 1)"
                },
                "surname-2-letters": {
                    label: "First 2 letters of preferred surname",
                    value: "surname.slice(0, 2)"
                },
                "surname-3-letters": {
                    label: "First 3 letters of preferred surname",
                    value: "surname.slice(0, 3)"
                },
                "email": {
                    label: "Email address",
                    value: "email"
                },
                "admission-number": {
                    label: "Admission number",
                    value: "admission_number"
                },
                "learner-number": {
                    label: "Learner number",
                    value: "learner_number"
                },
                "upn": {
                    label: "UPN",
                    value: "upn"
                }
            },
            visible: this.dialogVisible,
            processing: false,
        }
    },

    methods: {
        cancelModal() {
            this.$bus.emit("visibility-set", false);
            this.processing = false;
        },

        async confirmModal() {
            this.processing = true;

            const input = _.map(this.selected, (user) => {
                return {
                    key: "person_id",
                    value: this.format,
                    type: "string",
                    personId: user.id.toString(),
                };
            });

            await this.$apollo
                .mutate({
                    mutation: gql`
                        mutation UpdateUserCustomField($input: [UpdateUserCustomFieldInput!]!) {
                            UpdateUserCustomField(input: $input)
                        }
                    `,
                    variables: {
                        input 
                    },
                    update: (store, data) => {
                
                    }
                })
                .catch(e => {
                    Bugsnag.notify(e);
                    this.$message.error("Failed to update custom person id. Please contact support");
                    console.log(e);
                });
            this.cancelModal();
		}
    },

    watch: {

    }
};
</script>

